import api from './api';

export const announcementAPI = {
  // Get active announcements for current user
  getActive: () => api.get('/announcements/active'),
  // Get active public announcement (unauthenticated, Login page)
  getPublic: () => api.get('/announcements/public'),
};
